/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// other
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import { T社員マスタ } from "../../../components/ComboBox/SyainComboBox"
import {
  TUnkoKanrisyaListGetReq,
  TUnkoKanrisyaListInfo,
  TUnkoKanrisyaPutReq,
} from "../../../service/truckcontrol/unkokanrisya/TUnkoKanrisya"
import UnkokanrisyaService from "../../../service/truckcontrol/unkokanrisya/unkokanrisyaService"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { TApiResponse } from "../../../service/TApiResponse"
import { showInfoToast } from "../../../components/CustomToast"
import BusyoService from "../../../service/master/busyo/busyoService"
import SyainService from "../../../service/master/syain/syainService"

/**
 * 運行管理者マスタ
 * @returns
 */
const UnkoKanrisyaRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const { id } = useParams<{ id: string }>()

  //#region [baseState]

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<string | null>()
  const [統括運行管理者ID, set統括運行管理者id] = useState<number | null>()
  const [統括運行管理者更新日時, set統括運行管理者更新日時] = useState<
    string | null
  >()
  const [統括運行管理者, set統括運行管理者] = useState<string | null>()
  const [統括運行管理者Disabled, set統括運行管理者Disabled] =
    useState<boolean>(true)
  const [運行管理者１ID, set運行管理者１id] = useState<number | null>()
  const [運行管理者１更新日時, set運行管理者１更新日時] = useState<
    string | null
  >()
  const [運行管理者１, set運行管理者１] = useState<string | null>()
  const [運行管理者１Disabled, set運行管理者１Disabled] =
    useState<boolean>(true)
  const [運行管理者２ID, set運行管理者２id] = useState<number | null>()
  const [運行管理者２更新日時, set運行管理者２更新日時] = useState<
    string | null
  >()
  const [運行管理者２, set運行管理者２] = useState<string | null>()
  const [運行管理者２Disabled, set運行管理者２Disabled] =
    useState<boolean>(true)
  const [運行管理者３ID, set運行管理者３id] = useState<number | null>()
  const [運行管理者３更新日時, set運行管理者３更新日時] = useState<
    string | null
  >()
  const [運行管理者３, set運行管理者３] = useState<string | null>()
  const [運行管理者３Disabled, set運行管理者３Disabled] =
    useState<boolean>(true)

  const [運行管理補助者１ID, set運行管理補助者１id] = useState<number | null>()
  const [運行管理補助者１更新日時, set運行管理補助者１更新日時] = useState<
    string | null
  >()
  const [運行管理補助者１, set運行管理補助者１] = useState<string | null>()
  const [運行管理補助者１Disabled, set運行管理補助者１Disabled] =
    useState<boolean>(true)
  const [運行管理補助者２ID, set運行管理補助者２id] = useState<number | null>()
  const [運行管理補助者２更新日時, set運行管理補助者２更新日時] = useState<
    string | null
  >()
  const [運行管理補助者２, set運行管理補助者２] = useState<string | null>()
  const [運行管理補助者２Disabled, set運行管理補助者２Disabled] =
    useState<boolean>(true)
  const [運行管理補助者３ID, set運行管理補助者３id] = useState<number | null>()
  const [運行管理補助者３更新日時, set運行管理補助者３更新日時] = useState<
    string | null
  >()
  const [運行管理補助者３, set運行管理補助者３] = useState<string | null>()
  const [運行管理補助者３Disabled, set運行管理補助者３Disabled] =
    useState<boolean>(true)

  const [整備管理者１ID, set整備管理者１id] = useState<number | null>()
  const [整備管理者１更新日時, set整備管理者１更新日時] = useState<
    string | null
  >()
  const [整備管理者１, set整備管理者１] = useState<string | null>()
  const [整備管理者１Disabled, set整備管理者１Disabled] =
    useState<boolean>(true)
  const [整備管理者２ID, set整備管理者２id] = useState<number | null>()
  const [整備管理者２更新日時, set整備管理者２更新日時] = useState<
    string | null
  >()
  const [整備管理者２, set整備管理者２] = useState<string | null>()
  const [整備管理者２Disabled, set整備管理者２Disabled] =
    useState<boolean>(true)
  const [整備管理者３ID, set整備管理者３id] = useState<number | null>()
  const [整備管理者３更新日時, set整備管理者３更新日時] = useState<
    string | null
  >()
  const [整備管理者３, set整備管理者３] = useState<string | null>()
  const [整備管理者３Disabled, set整備管理者３Disabled] =
    useState<boolean>(true)

  const [整備管理補助者１ID, set整備管理補助者１id] = useState<number | null>()
  const [整備管理補助者１更新日時, set整備管理補助者１更新日時] = useState<
    string | null
  >()
  const [整備管理補助者１, set整備管理補助者１] = useState<string | null>()
  const [整備管理補助者１Disabled, set整備管理補助者１Disabled] =
    useState<boolean>(true)
  const [整備管理補助者２ID, set整備管理補助者２id] = useState<number | null>()
  const [整備管理補助者２更新日時, set整備管理補助者２更新日時] = useState<
    string | null
  >()
  const [整備管理補助者２, set整備管理補助者２] = useState<string | null>()
  const [整備管理補助者２Disabled, set整備管理補助者２Disabled] =
    useState<boolean>(true)
  const [整備管理補助者３ID, set整備管理補助者３id] = useState<number | null>()
  const [整備管理補助者３更新日時, set整備管理補助者３更新日時] = useState<
    string | null
  >()
  const [整備管理補助者３, set整備管理補助者３] = useState<string | null>()
  const [整備管理補助者３Disabled, set整備管理補助者３Disabled] =
    useState<boolean>(true)

  //#region [comboboxState]
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 社員
  const [社員ComboBox, set社員ComboBox] = useState<TWijmoComboBox<
    string,
    T社員マスタ
  > | null>(null)
  const [社員IsLoadEnded, set社員IsLoadEnded] = useState<boolean>(false)
  const [社員ItemSource, set社員ItemSource] = useState<T社員マスタ[]>()

  const [最終更新日時] = useState<string>()
  const [最終更新ID] = useState<string>()
  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#region [method]

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TUnkoKanrisyaListGetReq,
    signal?: AbortSignal
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    set統括運行管理者Disabled(false)
    set運行管理者１Disabled(false)
    set運行管理者２Disabled(false)
    set運行管理者３Disabled(false)
    set運行管理補助者１Disabled(false)
    set運行管理補助者２Disabled(false)
    set運行管理補助者３Disabled(false)
    set整備管理者１Disabled(false)
    set整備管理者２Disabled(false)
    set整備管理者３Disabled(false)
    set整備管理補助者１Disabled(false)
    set整備管理補助者２Disabled(false)
    set整備管理補助者３Disabled(false)

    set統括運行管理者id(null)
    set運行管理者１id(null)
    set運行管理者２id(null)
    set運行管理者３id(null)
    set運行管理補助者１id(null)
    set運行管理補助者２id(null)
    set運行管理補助者３id(null)
    set整備管理者１id(null)
    set整備管理者２id(null)
    set整備管理者３id(null)
    set整備管理補助者１id(null)
    set整備管理補助者２id(null)
    set整備管理補助者３id(null)

    set統括運行管理者更新日時(null)
    set運行管理者１更新日時(null)
    set運行管理者２更新日時(null)
    set運行管理者３更新日時(null)
    set運行管理補助者１更新日時(null)
    set運行管理補助者２更新日時(null)
    set運行管理補助者３更新日時(null)
    set整備管理者１更新日時(null)
    set整備管理者２更新日時(null)
    set整備管理者３更新日時(null)
    set整備管理補助者１更新日時(null)
    set整備管理補助者２更新日時(null)
    set整備管理補助者３更新日時(null)

    let currentSearchCondition: TUnkoKanrisyaListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      // 先に部所配下の社員一覧（乗務員は除く）を取得
      const 社員Res = await new SyainService().getList({
        // 部所コード: 部所コード ?? undefined,
        退職フラグ: 0,
      })
      社員Res && set社員ItemSource([...社員Res.data])

      //運行管理者マスタ一覧取得
      const res = await new UnkokanrisyaService().getList(
        currentSearchCondition,
        signal
      )

      // 検索結果をstateにセット
      if (res.data) {
        //運行管理者区分に該当するRecの社員コードを設定
        for (let i = 0; i < res.data.length; i++) {
          switch (res.data[i].運行管理者区分コード) {
            case "01": // 統括運行管理者
              set統括運行管理者id(res.data[i].運行管理者ID)
              set統括運行管理者(res.data[i].社員コード)
              set統括運行管理者更新日時(res.data[i].更新日時)
              break
            case "11": // 運行管理者1
              set運行管理者１id(res.data[i].運行管理者ID)
              set運行管理者１(res.data[i].社員コード)
              set運行管理者１更新日時(res.data[i].更新日時)
              break
            case "12": // 運行管理者2
              set運行管理者２id(res.data[i].運行管理者ID)
              set運行管理者２(res.data[i].社員コード)
              set運行管理者２更新日時(res.data[i].更新日時)
              break
            case "13": // 運行管理者3
              set運行管理者３id(res.data[i].運行管理者ID)
              set運行管理者３(res.data[i].社員コード)
              set運行管理者３更新日時(res.data[i].更新日時)
              break
            case "21": // 運行管理補助者1
              set運行管理補助者１id(res.data[i].運行管理者ID)
              set運行管理補助者１(res.data[i].社員コード)
              set運行管理補助者１更新日時(res.data[i].更新日時)
              break
            case "22": // 運行管理補助者2
              set運行管理補助者２id(res.data[i].運行管理者ID)
              set運行管理補助者２(res.data[i].社員コード)
              set運行管理補助者２更新日時(res.data[i].更新日時)
              break
            case "23": // 運行管理補助者3
              set運行管理補助者３id(res.data[i].運行管理者ID)
              set運行管理補助者３(res.data[i].社員コード)
              set運行管理補助者３更新日時(res.data[i].更新日時)
              break
            case "31": // 整備管理者1
              set整備管理者１id(res.data[i].運行管理者ID)
              set整備管理者１(res.data[i].社員コード)
              set整備管理者１更新日時(res.data[i].更新日時)
              break
            case "32": // 整備管理者2
              set部所コード(res.data[i].部所コード)
              set整備管理者２id(res.data[i].運行管理者ID)
              set整備管理者２(res.data[i].社員コード)
              set整備管理者２更新日時(res.data[i].更新日時)
              break
            case "33": // 整備管理者3
              set部所コード(res.data[i].部所コード)
              set整備管理者３id(res.data[i].運行管理者ID)
              set整備管理者３(res.data[i].社員コード)
              set整備管理者３更新日時(res.data[i].更新日時)
              break
            case "41": // 整備管理補助者1
              set整備管理補助者１id(res.data[i].運行管理者ID)
              set整備管理補助者１(res.data[i].社員コード)
              set整備管理補助者１更新日時(res.data[i].更新日時)
              break
            case "42": // 整備管理補助者2
              set部所コード(res.data[i].部所コード)
              set整備管理補助者２id(res.data[i].運行管理者ID)
              set整備管理補助者２(res.data[i].社員コード)
              set整備管理補助者２更新日時(res.data[i].更新日時)
              break
            case "43": // 整備管理補助者3
              set整備管理補助者３id(res.data[i].運行管理者ID)
              set整備管理補助者３(res.data[i].社員コード)
              set整備管理補助者３更新日時(res.data[i].更新日時)
              break

            default:
              break
          }
        }
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態を解除
    }
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TUnkoKanrisyaListGetReq => {
    return {
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (部所コード == null) return

      let data: TUnkoKanrisyaPutReq[] = [
        {
          運行管理者ID: 統括運行管理者ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "01",
          社員コード: 統括運行管理者 ?? "",
          更新日時: 統括運行管理者更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理者１ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "11",
          社員コード: 運行管理者１ ?? "",
          更新日時: 運行管理者１更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理者２ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "12",
          社員コード: 運行管理者２ ?? "",
          更新日時: 運行管理者２更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理者３ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "13",
          社員コード: 運行管理者３ ?? "",
          更新日時: 運行管理者３更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理補助者１ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "21",
          社員コード: 運行管理補助者１ ?? "",
          更新日時: 運行管理補助者１更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理補助者２ID ?? undefined,
          部所コード: 部所コード!,
          運行管理者区分コード: "22",
          社員コード: 運行管理補助者２ ?? "",
          更新日時: 運行管理補助者２更新日時 ?? undefined,
        },
        {
          運行管理者ID: 運行管理補助者３ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "23",
          社員コード: 運行管理補助者３ ?? "",
          更新日時: 運行管理補助者３更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理者１ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "31",
          社員コード: 整備管理者１ ?? "",
          更新日時: 整備管理者１更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理者２ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "32",
          社員コード: 整備管理者２ ?? "",
          更新日時: 整備管理者２更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理者３ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "33",
          社員コード: 整備管理者３ ?? "",
          更新日時: 整備管理者３更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理補助者１ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "41",
          社員コード: 整備管理補助者１ ?? "",
          更新日時: 整備管理補助者１更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理補助者２ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "42",
          社員コード: 整備管理補助者２ ?? "",
          更新日時: 整備管理補助者２更新日時 ?? undefined,
        },
        {
          運行管理者ID: 整備管理補助者３ID ?? undefined,
          部所コード: 部所コード,
          運行管理者区分コード: "43",
          社員コード: 整備管理補助者３ ?? "",
          更新日時: 整備管理補助者３更新日時 ?? undefined,
        },
      ]

      const service = new UnkokanrisyaService()

      let res: TApiResponse<TUnkoKanrisyaListInfo[]> = await service.putList(
        data
      )
      dispatch(setAlerts(res))
      if (res) {
        showInfoToast(`運行管理者マスタの${id ? "更新" : "登録"}が完了しました`)
        await search()
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const QR印刷 = async () => {
    setIsSearching(true)
    try {
      const 運行管理者IDList = [
        統括運行管理者ID,
        運行管理者１ID,
        運行管理者２ID,
        運行管理者３ID,
        運行管理補助者１ID,
        運行管理補助者２ID,
        運行管理補助者３ID,
        整備管理者１ID,
        整備管理者２ID,
        整備管理者３ID,
        整備管理補助者１ID,
        整備管理補助者２ID,
        整備管理補助者３ID,
      ].filter((e) => e !== null) as number[]

      const res = await new SyainService({
        responseType: "blob",
      }).printQRHashList(運行管理者IDList)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    //TODO: API より取得
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set社員ItemSource([])
    })
  }, [])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">運行管理者マスタ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* ==================== 検索条件カード ==================== */}
          <Card className="w-75rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="w-20rem">
                          <ComboBox.Busyo
                            placeholder="部所"
                            isRequired={true}
                            itemsSource={部所ItemSource}
                            isLoadEnded={部所IsLoadEnded}
                            setIsLoadEnded={set部所IsLoadEnded}
                            selectedValue={部所コード}
                            listFilter={(d) => d.運行部所フラグ === 1}
                            setSelectedValue={set部所コード}
                            ComboBox={部所ComboBox}
                            setComboBox={set部所ComboBox}></ComboBox.Busyo>
                        </div>
                      </Col>
                      <Col>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* ==================== 登録情報カード ==================== */}
          <Card className="w-75rem">
            <Card.Header>登録情報</Card.Header>
            <Card.Body>
              <Container fluid className="register-form">
                {/* 統括運行管理者 */}
                <MasterRegisterFormRow Width={20} label="統括運行管理者">
                  <div className="w-20rem">
                    <ComboBox.Syain
                      placeholder="統括運行管理者"
                      itemsSource={社員ItemSource}
                      isLoadEnded={社員IsLoadEnded}
                      setIsLoadEnded={set社員IsLoadEnded}
                      isEmpty={true}
                      isDisabled={統括運行管理者Disabled}
                      selectedValue={統括運行管理者}
                      listFilter={
                        (d) =>
                          // 乗務員以外
                          d.社員区分コード !== "30" && d.社員区分コード !== "31"
                        // d.社員区分コード === "15" ||
                        // d.社員区分コード === "20" ||
                        // d.社員区分コード === "25"
                      }
                      setSelectedValue={set統括運行管理者}
                      ComboBox={社員ComboBox}
                      setComboBox={set社員ComboBox}></ComboBox.Syain>
                  </div>
                </MasterRegisterFormRow>
              </Container>
              <br />
              <Container fluid className="register-form">
                {/* 運行管理者１ */}
                <MasterRegisterFormRow Width={20} label="運行管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理者１"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理者１Disabled}
                        selectedValue={運行管理者１}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          // d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理者１}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理補助者１"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理補助者１Disabled}
                        selectedValue={運行管理補助者１}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          // d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理補助者１}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
                {/* 運行管理者２ */}
                <MasterRegisterFormRow Width={20} label="運行管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理者２"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理者２Disabled}
                        selectedValue={運行管理者２}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理者２}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理補助者２"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理補助者２Disabled}
                        selectedValue={運行管理補助者２}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          // d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理補助者２}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
                {/* 運行管理者３ */}
                <MasterRegisterFormRow Width={20} label="運行管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理者３"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理者３Disabled}
                        selectedValue={運行管理者３}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理者３}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="運行管理補助者３"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={運行管理補助者３Disabled}
                        selectedValue={運行管理補助者３}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set運行管理補助者３}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
              </Container>
              <br />
              <Container fluid className="register-form">
                {/* 整備管理者１ */}
                <MasterRegisterFormRow Width={20} label="整備管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理者１"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理者１Disabled}
                        selectedValue={整備管理者１}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          // d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理者１}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理補助者１"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理補助者１Disabled}
                        selectedValue={整備管理補助者１}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理補助者１}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
                {/* 整備管理者２ */}
                <MasterRegisterFormRow Width={20} label="整備管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理者２"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理者２Disabled}
                        selectedValue={整備管理者２}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理者２}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理補助者２"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理補助者２Disabled}
                        selectedValue={整備管理補助者２}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理補助者２}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
                {/* 整備管理者３ */}
                <MasterRegisterFormRow Width={20} label="整備管理者・補助者">
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理者３"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理者３Disabled}
                        selectedValue={整備管理者３}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          //  d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理者３}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                  &nbsp;
                  <Col>
                    <div className="w-19rem">
                      <ComboBox.Syain
                        placeholder="整備管理補助者３"
                        itemsSource={社員ItemSource}
                        isLoadEnded={社員IsLoadEnded}
                        setIsLoadEnded={set社員IsLoadEnded}
                        isEmpty={true}
                        isDisabled={整備管理補助者３Disabled}
                        selectedValue={整備管理補助者３}
                        listFilter={
                          (d) =>
                            // 乗務員以外
                            d.社員区分コード !== "30" &&
                            d.社員区分コード !== "31"
                          // d.社員区分コード.slice(0, 1) === "2"
                        }
                        setSelectedValue={set整備管理補助者３}
                        ComboBox={社員ComboBox}
                        setComboBox={set社員ComboBox}></ComboBox.Syain>
                    </div>
                  </Col>
                </MasterRegisterFormRow>
              </Container>
              <br />
              {id && (
                <>
                  <Row>
                    <Col>
                      最終更新日時:
                      {util.date.format(最終更新日時, "YYYY/MM/DD HH:mm:ss")}
                    </Col>
                  </Row>
                  <Row>
                    <Col>最終更新ID : {最終更新ID}</Col>
                  </Row>
                </>
              )}
              <Row className="search-button">
                <Col xl={{ span: "auto", offset: 0 }}>
                  <Button
                    type="submit"
                    variant="waiting"
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      beforeSubmit()
                    }}>
                    {id ? `更新` : `登録`}
                  </Button>

                  <Button
                    type="button"
                    variant="success"
                    className="ms-1"
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      QR印刷()
                    }}>
                    QRコード印刷
                  </Button>
                </Col>
              </Row>
              <ConfirmModal
                isShow={isConfirmModalShow}
                hideHandler={setIsConfirmModalShow}
                submitHandler={submit}>
                入力された内容で{id ? "更新" : "登録"}しますか？
              </ConfirmModal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default UnkoKanrisyaRegister
